import {Theme} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import React, {useEffect, useState} from 'react';
import {LoadingOverlay} from '../../../components/LoadingOverlay/LoadingOverlay';
import {Page} from '../../../components/Page';
import PageHeader from '../../../components/PageHeader';
import SearchBar from '../../../components/SearchBar';
import {getMe} from '../../../graphql/auth';
import {OPERATOR} from '../../../graphql/common.datatypes';
import anyLoading from '../../../utils/anyLoading';
import getReports from './getReports.api';
import Results from './Results';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(3)
  },
  results: {
    marginTop: theme.spacing(3)
  }
}));

const ReportsList = () => {
  const classes = useStyles();
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [page, setPage] = useState(1);
  const userData = getMe();
  const userId = userData.data ? userData.data.me.id : -1;
  const title = 'Reports List';

  const getWereConstraints = (value: string) => {
    return {
      AND: [
        {column: 'name', operator: OPERATOR.LIKE, value: `%${value}%`},
        {
          OR: [
            {column: 'shared', operator: OPERATOR.EQ, value: true},
            {column: 'user_id', operator: OPERATOR.EQ, value: userId},
          ]}
      ]
    };
  };

  const [where, setWhere] = useState(getWereConstraints(''));
  const reportsData = getReports(rowsPerPage, page, where);
  const loadingData = anyLoading(userData, reportsData);

  const handleSearch = (value: string) => {
    setWhere(getWereConstraints(value));
  };

  useEffect(() => {
    setPage(1);
  }, [rowsPerPage]);

  return (
    <Page className={classes.root} title={title}>
      <PageHeader section="Reports" title={title} action={{
        permission: 'reports.create',
        route: '/reports/new',
        label: 'New Report',
      }}/>
      <SearchBar onSearch={handleSearch} />
      <LoadingOverlay loading={loadingData.loading}>
        {reportsData.data && reportsData.data.reports && (
          <Results
            title="Reports"
            className={classes.results}
            data={reportsData.data.reports.data}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
            paginatorInfo={reportsData.data.reports.paginatorInfo}
            setPage={setPage}
          />
        )}
      </LoadingOverlay>
    </Page>
  );
};

export default ReportsList;
